import { EntityViewRecordScope, MetadataEntityData, MetadataEntityRecordScope } from '@jms/model';
import { pluralize } from 'inflected';
import { resolveSecondaryMetadata } from '../../state/features/with.metadata';

/** The word a group-header count is counting: the board's RECORD grain, singular and plural. */
export type BoardRecordNoun = {
  singular: string;
  plural: string;
};

const FALLBACK_NOUN: BoardRecordNoun = { singular: 'record', plural: 'records' };

/**
 * The noun for one record on the board.
 *
 * A Stages board pages at Secondary grain, so a lane holding 47 rows holds 47 STAGES, not 47 jobs —
 * the same job appears once per stage. Reading the grain's own display name is what keeps the header
 * honest when a board is mounted at either grain over the same entity.
 */
export function resolveBoardRecordNoun(metadata: MetadataEntityData | null | undefined, recordScope: EntityViewRecordScope | null | undefined): BoardRecordNoun {

  const grainMetadata = recordScope === MetadataEntityRecordScope.Secondary
    ? resolveSecondaryMetadata(metadata)
    : metadata;

  const displayName = grainMetadata?.displayName ?? grainMetadata?.name;
  if (!displayName) return FALLBACK_NOUN;

  return { singular: displayName.toLowerCase(), plural: pluralize(displayName).toLowerCase() };
}

/** `1 stage` / `24,997 stages` — the count and its noun, agreeing in number and grouped for reading. */
export function formatBoardRecordCount(count: number, noun: BoardRecordNoun): string {

  return `${formatBoardCount(count)} ${count === 1 ? noun.singular : noun.plural}`;
}

/** A lane total runs to five figures on a real tenant, so it is grouped rather than left as raw digits. */
export function formatBoardCount(count: number): string {

  return count.toLocaleString('en-AU');
}
